import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useGPTGameTrigger } from 'src/EXPERIMENTAL_LIB/modules/gpt/games';
import { useRoute } from 'src/router/hooks';

export const LuckyPigeonOpener = () => {
  const navigate = useNavigate();
  const { ROUTE } = useRoute();
  const {
    i18n: { language: lang }
  } = useTranslation();

  const { triggerGPTGame } = useGPTGameTrigger();

  useEffect(() => {
    triggerGPTGame('birdGame', { lang });
    navigate(ROUTE.MAIN.get());
  }, []);

  return <></>;
};
